import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import ListingCard from "./ListingCard";
import { api } from "../lib/api";

export default function MarketplacePreview() {
  const [listings, setListings] = useState([]);

  useEffect(() => {
    api.get("/listings").then(({ data }) => setListings(data.slice(0, 6))).catch(() => {});
  }, []);

  return (
    <section id="marketplace" data-testid="marketplace-section" className="relative bg-[var(--bg-concrete)] text-[var(--text-dark)] py-24 md:py-36">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <Reveal>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--accent)]">/ Marketplace</span>
            <h2 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter mt-4 leading-[0.9]">Second-hand,<br />first-rate.</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/marketplace" data-testid="marketplace-viewall" className="inline-flex items-center gap-2 border-b-2 border-black pb-1 font-mono text-sm uppercase tracking-widest hover:text-[var(--accent)] hover:border-[var(--accent)] transition-colors">
              Shop all listings <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>

        {listings.length === 0 ? (
          <p className="font-mono text-sm text-[#555]">Fresh finds landing soon — check back shortly.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {listings.map((l, i) => (
              <Reveal key={l.id} delay={i * 0.05}>
                <ListingCard listing={l} testid={`preview-listing-${l.id}`} />
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
